// extracted by mini-css-extract-plugin
export default {"p_tye":"fd52e2b23a","slcted":"cce6d40f74","slc_color":"dd851f66cb","item_p":"_756d4b6d2d","r0":"_02e55fc69e"};